import React from "react";
import { ScNavBar } from "./styled";
import { useRecoilState } from "recoil";
import { brightnessState, contrastState } from "../markupAtoms";

export const NavBar: React.FC = ({ children }) => {
  const [contrast, setContrast] = useRecoilState(contrastState);
  const [brightness, setBrightness] = useRecoilState(brightnessState);

  return (
    <ScNavBar>
      <div className="nav-bar-container">
        <div className="navigation">
          <div className="image-filter">
            <span>Яркость</span>
            <input
              type="range"
              min={-1}
              max={1}
              step={0.01}
              defaultValue={brightness}
              onChange={(e) => setBrightness(Number(e.target.value))}
            />
          </div>
          <div className="image-filter">
            <span>Контрастность</span>
            <input
              type="range"
              min={-100}
              max={100}
              defaultValue={contrast}
              onChange={(e) => setContrast(Number(e.target.value))}
            />
          </div>
        </div>
      </div>
      {children}
    </ScNavBar>
  );
};
